<!-- =========================================================================================
    File Name: Chat.vue
    Description: Chat Application - Stay connected
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    id="chat-app"
    class="border border-solid border-grey-light rounded relative overflow-hidden"
  >
    <vs-sidebar
      ref="chat_list_sidebar"
      class="items-no-padding"
      parent="#chat-app"
      :click-not-close="clickNotClose"
      :hidden-background="clickNotClose"
      v-model="isChatSidebarActive"
      id="chat-list-sidebar"
    >
      <div class="chat__profile-top flex justify-between">
        <div class="flex p-4">
          <div class="relative inline-flex">
            <vs-avatar
              class="m-0"
              :src="profilePic"
              size="40px"
            />
            <div
              class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b"
              :class="'bg-' + getStatusColor(true)"
            ></div>
          </div>
        </div>
        <div v-if="mentorSessionActive && $acl.not.check('Mentor')" class="self-center pr-1 chat__start-new">
          <vs-button icon-pack="feather" icon="icon-plus" type="flat" color="success" @click="popupActive = true"><strong>Start New Chat</strong></vs-button>
        </div>
      </div>
      <div class="chat__profile-search flex pt-4">
        <vs-input
          icon="icon-search"
          icon-pack="feather"
          class="w-full mx-5 input-rounded-full no-icon-border"
          placeholder="Search or start a new chat"
          v-model="searchQuery"
        />
      </div>
      <vs-divider />

      <!-- <vs-divider class="m-0" /> -->
      <VuePerfectScrollbar class="chat-scroll-area" :settings="settings">
        <!-- ACTIVE CHATS LIST -->
        <div class="chat__chats-list mb-8">
          <h3 class="text__school-font-color mb-5 px-4">{{ mentorSessionActive ? 'Sessions' : 'Groups' }}</h3>
          <ul class="chat__active-chats bordered-items">
            <li
              class="cursor-pointer"
              v-for="(contact, index) in groups"
              :key="index"
              @click="updateActiveGroup(contact)"
            >
              <chat-contact
                :contact="contact"
                :lastMessaged="chatLastMessaged(contact.id).time"
                :unseenMsg="chatUnseenMessages(contact.id)"
                :isActiveChatUser="isActiveChatUser(contact.id)"
              ></chat-contact>
            </li>
            <p v-if="groups.length == 0" class="text-center text-white font-bold" style="font-size:14px">You have no active sessions</p>
            <!-- <vs-button @click="stopConnection">Stop Connection</vs-button> -->
          </ul>
        </div>

        <!-- CONTACTS LIST -->
        <!-- <div class="chat__contacts">
          <h3 class="text__school-font-color mb-5 px-4">Contacts</h3>
          <ul class="chat__contacts bordered-items">
            <li
              class="cursor-pointer"
              v-for="contact in chatContacts"
              :key="contact.id"
              @click="updateActiveGroup(contact)"
            >
              <chat-contact :contact="contact"></chat-contact>
            </li>
          </ul>
        </div> -->
      </VuePerfectScrollbar>
    </vs-sidebar>

    <!-- RIGHT COLUMN -->
    <div
      class="chat__bg app-fixed-height chat-content-area border border-solid border-grey-light border-t-0 border-r-0 border-b-0"
      :class="{
        'sidebar-spacer--wide': clickNotClose,
        'flex items-center justify-center': activeGroupId === null,
      }"
    >
      <template v-if="activeGroupId">
        <div class="chat__navbar">
          <chat-navbar
            :isSidebarCollapsed="!clickNotClose"
            :activeUser="selectedContact"
            :isPinnedProp="isChatPinned"
            @openContactsSidebar="toggleChatSidebar(true)"
            @showEndChatPopup="endChatPopupActive = true"
          ></chat-navbar>
        </div>
        <VuePerfectScrollbar
          class="chat-content-scroll-area border border-solid border-grey-light"
          :settings="settings"
          ref="chatLogPS"
        >
          <div class="chat__log" ref="chatLog">
            <chat-log :userId="activeGroupId" v-if="activeGroupId" :chatData="chatData"></chat-log>
          </div>
        </VuePerfectScrollbar>
        <div class="chat__input flex p-4 bg-white">
          <vs-input
            class="flex-1"
            placeholder="Type a message"
            v-model="typedMessage"
            @keyup.enter="sendMsg"
          />
          <vs-button id="send-btn" v-if="typedMessage" radius class="bg-primary-gradient ml-4" type="filled" @click="sendMsg" icon-pack="feather" icon="icon-send"></vs-button>
        </div>
      </template>
      <template v-else>
        <div class="flex flex-col items-center">
          <h4
            class="py-2 px-4 bg-white shadow-md rounded-full cursor-pointer"
            @click.stop="toggleChatSidebar(true)"
          >
            Open Chat Menu 
          </h4> 
        </div>
      </template>
    </div>

    <vs-popup title="Start New Chat" id="init-chat-popup" :active.sync="popupActive">
      <div class="vx-row">
        <div class="vx-col w-full">
          <label for="chat_name">Enter a Name</label>
          <vs-input autocomplete="off" id="chat_name" class="w-full mt-1" v-model="startNewChatData.groupName" />
        </div>
      </div>
      <div class="vx-row mt-3">
        <div class="vx-col w-full">
          <label for="chat_message">Message</label>
          <vs-textarea id="chat_message" class="mt-1" v-model="startNewChatData.message" />
        </div>
      </div>
      <div class="vx-row mt-3">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button class="vs-con-loading__container" ref="submit_btn" @click="initiateMentoringSession">Submit</vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Are you sure you want to end the chat session?" id="end-chat-popup" :active.sync="endChatPopupActive">
      <div class="vx-row">
        <div class="vx-col w-full">
          <label for="chat_message">Comments:</label>
          <vs-textarea id="chat_message" class="mt-1" v-model="endChatData.description" />
        </div>
      </div>
      <div class="vx-row mt-3">
        <div class="vx-col w-full">
          <div class="flex helpful_btns__container justify-center">
            <vs-button id="helpful-btn" class="vs-con-loading__container helpful_btns" ref="submit_btn" color="success" icon-pack="feather" icon="icon-check-circle" @click="endChat(true)">Helpful</vs-button>
            <vs-button id="unhelpful-btn" class="vs-con-loading__container helpful_btns" ref="submit_btn" color="danger" icon-pack="feather" icon="icon-x-circle" icon-after @click="endChat(false)">Not Helpful</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ChatContact from "./ChatContact.vue";
import UserProfile from "./UserProfile.vue";
import ChatNavbar from "./ChatNavbar.vue";
import ChatLog from "./ChatLog.vue";
import * as signalR from "@aspnet/signalr";
export default {
  components: {
    VuePerfectScrollbar,
    ChatContact,
    UserProfile,
    ChatNavbar,
    ChatLog,
  },
  data() {
    return {
      active: true,
      isHidden: false,
      searchContact: "",
      activeProfileSidebar: false,
      activeGroupId: null,
      userProfileId: -1,
      typedMessage: "",
      isChatPinned: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7,
      },
      clickNotClose: true,
      isChatSidebarActive: true,
      windowWidth: window.innerWidth,
      connection: null,
      chatData: [],
      selectedContact: {},
      groups: [],
      mentorSessionActive: false,
      popupActive: false,
      startNewChatData: {
        groupName: "",
        message: "",
        moduleId: null,
        studentId: null
      },
      selectedMentorModuleId: null,
      endChatPopupActive: false,
      endChatData: {
        description: "",
        helpful: false
      }
    };
  },
  watch: {
    popupActive: function(val) {
      if (!val) {
        this.startNewChatData.groupName = "";
        this.startNewChatData.message = "";
      }
    }
  },
  computed: {
    profilePic() {
      return JSON.parse(localStorage.getItem('userInfo')).profilePictureUrl;
    },
    chatLastMessaged() {
      return (userId) => this.$store.getters["chat/chatLastMessaged"](userId);
    },
    chatUnseenMessages() {
      return (userId) => {
        const unseenMsg = this.$store.getters["chat/chatUnseenMessages"](
          userId
        );
        if (unseenMsg) return unseenMsg;
      };
    },
    activeUserId() {
      return this.$store.state.AppActiveUser.id;
    },
    activeUserImg() {
      return this.$store.state.AppActiveUser.img;
    },
    activeUserStatus() {
      return this.$store.state.AppActiveUser.status;
    },
    getStatusColor() {
      return () => {
        if (this.connection && this.connection.state === signalR.HubConnectionState.Connected) {
          return "success";
        }
        else {
          return "danger"
        }
      }
    },
    searchQuery: {
      get() {
        return this.$store.state.chat.chatSearchQuery;
      },
      set(val) {
        this.$store.dispatch("chat/setChatSearchQuery", val);
      },
    },
    isActiveChatUser() {
      return (userId) => userId == this.activeGroupId;
    },
  },
  methods: {
    init() {
      var self = this;

      self.$store.dispatch("updateTheme", "dark");
      self.connection = new signalR.HubConnectionBuilder()
        .withUrl(`${self.$VUE_APP_SIGNALR}`, {
        //skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets
      }).build();

      self.showLoadingOnElement("chat_list_sidebar", 1, "material");

      self.connection.start()
      .then(function() {
        if (self.mentorSessionActive && self.$acl.check("Student")) {
          self.getMentorChatSessionsStudent()
        }
        else {
          if (self.$acl.check("Mentor") && self.mentorSessionActive) {
            self.getMentorSessions();
          }
          else if (self.$acl.check("Teacher")) {
            self.getTeacherGroups();
          }
          else if (self.$acl.check("Student")) {
            self.getGroups();
          }
        }
      })
      .catch(function(err) {
        return console.error(err.toString());
      })
      .finally(function() {
        self.$vs.loading.close(self.$refs.chat_list_sidebar.$el);
      });

      self.connection.on("Send", (userId, displayName, data, group) => {
        // const insertdata = { name: user, message: data };
        var isSameUser = userId == localStorage.getItem('Current_User_Id');
        var msg = {
          'sender': isSameUser ? '' : `${displayName}`,
          'textContent': data,
          'time': String(new Date()),
          'isSent': isSameUser,
          'isSeen': false,
          'senderId': userId
        };
        const insertdata = { name: self.selectedContact.name, msg: msg, isPinned: self.isChatPinned, id: self.activeGroupId };
        self.chatData.push(insertdata);
      });
    },
    stopConnection() {
      this.connection.stop();
    },
    getGroups() {
      var self = this;
      self.showLoadingOnElement("chat_list_sidebar", 1, "material");

      var onSuccess = response => {
        self.groups = response.data;
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.chat_list_sidebar.$el);
      };

      self.$ajaxGet(self, "ChatGroup/GetGroups", onSuccess, onFinally);
    },
    getTeacherGroups() {
      var self = this;
      self.showLoadingOnElement("chat_list_sidebar", 1, "material");

      var onSuccess = response => {
        self.groups = response.data;
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.chat_list_sidebar.$el);
      };

      self.$ajaxGet(self, "ChatGroup/GetTeacherGroups", onSuccess, onFinally);
    },
    getMentorSessions() {
      var self = this;
      self.showLoadingOnElement("chat_list_sidebar", 1, "material");

      var onSuccess = response => {
        self.groups = response.data;
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.chat_list_sidebar.$el);
      };

      self.$ajaxGet(self, "ChatGroup/GetMentorSessions", onSuccess, onFinally);
    },
    getMentorChatSessionsStudent() {
      var self = this;
      self.showLoadingOnElement("chat_list_sidebar", 1, "material");

      if (self.$route.params.sessionData) {
        self.selectedMentorModuleId = self.$route.params.sessionData.moduleId;
      }

      var onSuccess = response => {
        self.groups = response.data;

        if (self.$route.params.sessionData) {
          self.updateActiveGroup(self.$route.params.sessionData);
        }
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.chat_list_sidebar.$el);
      };

      self.$ajaxGet(self, "ChatGroup/GetMentorChatSessionsStudent?moduleId=" + self.selectedMentorModuleId, onSuccess, onFinally);
    },
    sendMsg() {
      var self = this;
      if (!self.typedMessage) return;

      if (self.connection && self.connection.state === signalR.HubConnectionState.Connected) {
        self.connection.invoke("SendMessage", localStorage.getItem('Current_User_Id'), JSON.parse(localStorage.getItem('userInfo')).displayName, self.typedMessage, self.activeGroupId, true);
        self.typedMessage = "";

        self.$refs.chatLogPS.$el.scrollTop = self.$refs.chatLog.scrollHeight;
      }
      else {
        self.$vs.dialog({
          type: "confirm",
          color: 'success',
          title: 'You are not connected',
          text: 'It seems that you have been disconnected from the Chat Server.\n\nClick the button below to reconnect...',
          accept: self.reloadPage,
          cancel: self.reloadPage,
          acceptText: "Reconnect!",
        })
      }
    },
    updateUserProfileId(userId) {
      this.userProfileId = userId;
      this.activeProfileSidebar = !this.activeProfileSidebar;
    },
    updateActiveGroup(group) {
      var self = this;
      self.chatData = [];
      if (self.connection && self.connection.state === signalR.HubConnectionState.Connected) {
        self.selectedContact = group;
        self.activeGroupId = group.id;
        
        try {
          self.connection.invoke("LeaveGroup", self.activeGroupId);
        }
        catch {
          
        }

        self.connection.invoke("AddToGroup", self.activeGroupId).catch(function(err) {
          return console.error(err.toString());
        });
        
        self.toggleChatSidebar();
        self.typedMessage = "";

        self.loadGroupMessages();
      }
      else {
        self.$vs.dialog({
          type: "confirm",
          color: 'success',
          title: 'You are not connected',
          text: 'It seems that you have been disconnected from the Chat Server.\n\nClick the button below to reconnect...',
          accept: self.reloadPage,
          cancel: self.reloadPage,
          acceptText: "Reconnect!",
        })
      }
    },
    loadGroupMessages() {
      var self = this;
      self.showLoadingOnElement("chat_list_sidebar", 1, "material");

      var onSuccess = response => {
        var isSameUser = null;

        response.data.messageDetails.forEach(function(item) {
          isSameUser = item.userId == localStorage.getItem('Current_User_Id');

          var msg = {
            'sender': isSameUser ? '' : `${item.userName}`,
            'textContent': item.messageText,
            'time': item.date,
            'isSent': isSameUser,
            'isSeen': false,
            'senderId': item.userId
          };
          const insertdata = { name: self.selectedContact.name, msg: msg, isPinned: self.isChatPinned, id: item.chatGroupId };
          self.chatData.push(insertdata);
        });

        
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.chat_list_sidebar.$el);
      };

      self.$ajaxGet(self, "ChatMessage/GetMessagesByChatGroup?chatGroupId=" + self.activeGroupId, onSuccess, onFinally);
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.isChatSidebarActive = this.clickNotClose = false;
      } else {
        this.isChatSidebarActive = this.clickNotClose = true;
      }
    },
    toggleChatSidebar(value = false) {
      if (!value && this.clickNotClose) return;
      this.isChatSidebarActive = value;
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    reloadPage() {
      this.$router.go();
    },
    initiateMentoringSession() {
      var self = this;
      self.showLoadingOnElement("submit_btn", 0.45, "material");

      self.startNewChatData.moduleId = self.selectedMentorModuleId;
      self.startNewChatData.studentId = localStorage.getItem("Current_User_Id");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.submit_btn.$el);
        self.popupActive = false;
        self.getMentorChatSessionsStudent();
      };
      var onFinally = response => {
        if (self.$refs.submit_btn) {
          self.$vs.loading.close(self.$refs.submit_btn.$el);
        }
      };

      self.$ajaxPost(self, "MentorModule/InitiateMentoringSession", self.startNewChatData, onSuccess, onFinally);
    },
    endChat(val) {
      var self = this;
      self.endChatData.helpful = val;

      var onSuccess = response => {
        self.endChatPopupActive = false;
        self.activeGroupId = null;
        self.selectedContact = {};
        self.endChatData.description = "";
        self.getMentorChatSessionsStudent();
      };

      self.$ajaxGet(self, "MentorModule/ConcludeMentorChat?mentorSessionId=" + self.selectedContact.mentorSessionId + "&description=" + self.endChatData.description + "&helpful=" + self.endChatData.helpful, onSuccess);
    }
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    this.setSidebarWidth();
  },
  beforeDestroy() {
    this.connection.stop();
    window.removeEventListener("resize", this.handleWindowResize);
  },
  mounted() {
    this.mentorSessionActive = this.$route.query.mentoring;
    this.selectedMentorModuleId = this.$route.query.module;
    this.init();
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/apps/chat.scss";

#end-chat-popup,
#init-chat-popup {
  .vs-component.vs-con-textarea.vs-textarea-primary:not(.focusx){
    border-color: #828282 !important;
  }

  .focusx.vs-textarea-primary {
    border: 1px solid rgba(var(--vs-primary),1)!important;
  }
}

.helpful_btns__container {
  .helpful_btns {
    .vs-button--text {
      text-transform: uppercase !important;
    }

    .vs-icon {
      font-size: 1.2rem !important;
    }

    width: 190px !important;
  }

  #helpful-btn {
    border-radius: 25px 0 0 25px !important;
  }

  #unhelpful-btn {
    border-radius: 0 25px 25px 0 !important;
  }
}
</style>